import UserinfoInmyProfile from './UserinfoInmyProfile';
import PersonalInformation from './PersonalInformation';
import MySubcription from './MySubcription';
import { getToken } from '../utils';

function MyProfilePage() {
  const user = getToken()?.user;
  return (
    <section>
      <div className=' bg-t-wh mb-6 px-5 lg:px-32 py-4 md:py-8'>
        <UserinfoInmyProfile user={user} />
      </div>
      <div className='space-y-12 px-5 md:px-32 py-4 md:py-12'>
        <PersonalInformation user={user} />
        <MySubcription user={user} />
      </div>
    </section>
  );
}

export default MyProfilePage;
